import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { HelmetProvider } from 'react-helmet-async';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import HomePage from './components/HomePage';
import AboutPage from './components/AboutPage';
import DeleteDataPage from './components/DeleteDataPage';
import Policy from "./components/Policy";
import TermsofService from "./components/TermsofService";
import FAQPage from "./components/FAQPage";
import ContactPage from "./components/ContactPage";
import ScrollToTop from './components/ScrollToTop';
import BlogIndexPage from './components/BlogIndexPage';
import BlogPostPage from './components/BlogPostPage';
import CalculatorsPage from './components/CalculatorsPage';

export default function App() {
    const [page, setPage] = useState('home');

    return (
        <HelmetProvider>
            <Router>
                <ScrollToTop />

                <div className="bg-[#fafcfa] min-h-screen font-sans">
                    <Navbar setPage={setPage} />
                    <main>
                        <Routes>
                            <Route path="/" element={<HomePage setPage={setPage} />} />
                            <Route path="/about" element={<AboutPage />} />
                            <Route path="/contact" element={<ContactPage />} />
                            <Route path="/deleteData" element={<DeleteDataPage />} />
                            <Route path="/policy" element={<Policy />} />
                            <Route path="/terms" element={<TermsofService />} />
                            <Route path="/faq" element={<FAQPage />} />
                            <Route path="/blog" element={<BlogIndexPage />} />
                            <Route path="/calculators" element={<CalculatorsPage />} />
                            <Route path="/:slug" element={<BlogPostPage />} />
                        </Routes>
                    </main>
                    <Footer />
                </div>
            </Router>
        </HelmetProvider>
    );
}